export enum SalesEnquiryFollowUpType {
	Phone = 0,
	Email = 10,
	Meeting = 30,
	LinkedIn = 40,
	Other = 50,

}